import $ from 'jquery';

$(document).ready(function(){

  const parallax = $(".main-content");
  const speed = -0.25;

  window.onscroll = function() {
    parallax.each(function(i, el) {

      const windowYOffset = window.pageYOffset;
      const elBackgroundPos = (windowYOffset * speed + i * 200) + "px";

      el.style.backgroundPositionY = elBackgroundPos;

    });
  }

});